var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1752.7 173",
    style: {
      enableBackground: "new 0 0 1752.7 173"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4C01A;}\n\t.st1{fill:none;stroke:#F4C01A;stroke-width:2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "circle-begin",
    className: "st0",
    cx: 313.6,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle-end",
    className: "st0",
    cx: 1171.6,
    cy: 166.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "line",
    className: "st1",
    points: "313.6,6.5 313.6,98.5 1171.6,98.5 1171.6,166.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/line-1.a102145b824e39e71949e39c4fb09409.svg";
export { ForwardRef as ReactComponent };